export const getDefaultState = () => {
  const alertPrototype = {
    alertText: null,
    alertLink: null,
    dateStart: null,
    dateEnd: null,
    dimissible: null,
    alertDisplayType: [],
    alertSeverity: [],
    inactive: null,
    isViewed: null
  };

  return {
    alerts: [],
    alertDisplayTypes: [],
    alertSeverities: [],
    alert: {
      ...alertPrototype
    },
    dbAlert: {
      ...alertPrototype
    }
  };
};

export default {
  ...getDefaultState()
};
